import { customElement } from 'lit/decorators';
import { css } from 'lit';
import AtaButton, { ataButtonStyles } from './AtaButton';

declare global {
    interface HTMLElementTagNameMap {
        'ata-stroked-button': AtaStrokedButton;
    }
}

@customElement('ata-stroked-button')
export default class AtaStrokedButton extends AtaButton {
    static styles = [
        ataButtonStyles,
        css`
            a,
            button {
                ---ataButton--backgroundColor: transparent;
                ---ataButton--foregroundColor: var(--ata--button--color);
                ---ataButton--borderColor: var(--ata--button--borderColor);
            }
        `,
    ];
}
